import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserComponent } from './user/user.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { ValidateService } from './services/validate.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './gards/auth.gard';
import { CalculatorService } from './services/calculator.service';


import { LogoutComponent } from './logout/logout.component';
import { QuicksearchComponent } from './quicksearch/quicksearch.component';

const appRouts : Routes = [
  {path :'', component : HomeComponent, canActivate: [AuthGuard]},
  {path :'dashboard', component : HomeComponent, canActivate: [AuthGuard]},
  {path :'user', component : UserComponent, canActivate: [AuthGuard]},
  {path :'login', component : LoginComponent},
  {path :'logout', component : LogoutComponent},
  {path :'signup', component : SignupComponent},
  {path :'quicksearch', component : QuicksearchComponent}
]

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    UserComponent,
    HomeComponent,
    LoginComponent,
    SignupComponent,
    LogoutComponent,
    QuicksearchComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRouts),
    FlashMessagesModule
  ],
  providers: [ValidateService, AuthService, AuthGuard, CalculatorService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts